var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"halo-tree"},_vm._l((_vm.data),function(item,index){return (item.show != false)?_c('treeLi',_vm._b({key:item.id ? item.id : index,attrs:{"item":item,"index":index}},'treeLi',_vm.childBind,false)):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }